import React from "react";
import buttonList from "./ButtonRenderer";
import "./index.less";

import PageTabs from "../../components/PageTabs";

export default () => {
  return <PageTabs buttonList={buttonList} />;
};
